// extracted by mini-css-extract-plugin
export default {"section":"CardOfBanners_section__HfToh","ecosystem-color":"CardOfBanners_ecosystem-color__MgNOD","dapp-color":"CardOfBanners_dapp-color__F1s-e"};